<template>
  <div class="app">
    <ReliefMap />
  </div>
</template>

<script>
import ReliefMap from './components/Map_Avignon.vue';

export default {
  name: 'App',
  components: { ReliefMap },
};
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
  height: 100%;
}
.app {
  width: 100vw;
  height: 100vh;
}
</style>